<template>
    <div class="searchLoading__overlay">
        <div class="searchLoading__wrapper fadeIn z-index-1">
            <div class="cssPreloader">
                <div class="cssPreloader__inner"></div>
            </div>
            <div class="h5 subline margin-bottom-0">
                {{ trans('PLEASE_WAIT') }}
            </div>
        </div>
    </div>
</template>

<script>
    import Translator from 'tools/trans';

    export default {
        // eslint-disable-next-line vue/component-definition-name-casing
        name: 'loading',
        setup() {
            return {
                trans: Translator.trans,
            };
        },
    };
</script>
